export const getFirstAddressRow = (addressListResponse) => {
  if (
    !addressListResponse ||
    !Array.isArray(addressListResponse.rows) ||
    addressListResponse.rows.length === 0
  ) {
    return null;
  }

  return addressListResponse.rows[0] || null;
};

export const normalizeAddress = (address = '') =>
  String(address ?? '').replace(/\s+/g, '');

export const parseAddressDetailResponse = (response, successCode) => {
  if (response?.code !== successCode) {
    const error = new Error(response?.reason || '取得地址明細失敗');
    error.code = response?.code || '';
    throw error;
  }

  return response.data ?? [];
};

export const findUniqueAddressRow = (addressListResponse, addressData = {}) => {
  const rows = Array.isArray(addressListResponse?.rows)
    ? addressListResponse.rows
    : [];
  const normalizedAddress = normalizeAddress(addressData.address);
  const expectedName = String(addressData.fullName ?? '').trim();
  const expectedPhone = String(addressData.phone ?? '').trim();
  const expectedStoreId = String(addressData.defaultStoreId ?? '').trim();

  if (
    !normalizedAddress ||
    !expectedPhone ||
    !expectedName ||
    !expectedStoreId
  ) {
    return null;
  }

  const matches = rows.filter(
    (row) =>
      String(row?.fullName ?? '').trim() === expectedName &&
      String(row?.phone ?? '').trim() === expectedPhone &&
      normalizeAddress(row?.address) === normalizedAddress &&
      String(row?.defaultStoreId ?? '').trim() === expectedStoreId
  );

  return matches.length === 1 ? matches[0] : null;
};

export const buildDispatchDataFromAddress = (
  currentDispatchData = {},
  addressDetail = {},
  store = {}
) => ({
  ...currentDispatchData,
  storeId: addressDetail.defaultStoreId ?? store.id ?? '',
  storeName: addressDetail.defaultStoreName ?? store.name ?? '',
  storeAddress: addressDetail.defaultStoreAddress ?? store.address ?? '',
  receiverName: addressDetail.fullName ?? '',
  receiverPhone: addressDetail.phone ?? '',
  receiverAddress: addressDetail.address ?? '',
  receiverElevator: addressDetail.deliveryIsElevator ? '1' : '0',
  receiverReceive: addressDetail.deliveryPointValue ?? '',
  receiverAddressRemark: addressDetail.deliveryNote ?? '',
  addressId: addressDetail.addressId ?? '',
  AddressUuid: addressDetail.AddressUuid ?? '',
});

export const buildDispatchDataFromAddressDetail = (
  currentDispatchData = {},
  addressDetail = {}
) => ({
  ...currentDispatchData,
  receiverAddress: addressDetail.address,
  storeId: addressDetail.defaultStoreId,
  storeAddress: addressDetail.defaultStoreAddress,
  storeName: addressDetail.defaultStoreName,
  receiverName: addressDetail.fullName ?? '',
  receiverPhone: addressDetail.phone,
  receiverElevator: addressDetail?.deliveryIsElevator ? '1' : '0',
  receiverReceive: addressDetail.deliveryPointValue,
  receiverAddressRemark: addressDetail.deliveryNote,
  remark: currentDispatchData.remark || '',
  addressId: addressDetail.addressId,
  address: addressDetail.address,
  floor: addressDetail.floor,
  AddressUuid: addressDetail.AddressUuid || '',
});
